import { createStyles, rem } from '@mantine/core'

export interface StylesParams {
  showFullSlide?: boolean
}

export default createStyles((theme, { showFullSlide }: StylesParams) => {
  return {
    arrow: {
      position: 'absolute',
      top: `50%`,
      transform: 'translateY(-50%)',
      zIndex: 2,
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'white',
      cursor: 'pointer',
      transition: 'all .2s ease',
      userSelect: 'none',
      '&:hover': {
        backgroundColor: theme.colors.neutral100,
        borderColor: theme.colors.neutral100,
      },
      '&.disabled': {
        opacity: 0,
        cursor: 'inherit',
      },
      ...(showFullSlide
        ? {
            width: rem(40),
            height: rem(40),
            opacity: 0.85,
            boxShadow: `1px 4px 8px 1px rgba(0, 0, 0, 0.1)`,
          }
        : {
            width: rem(30),
            height: rem(30),
            border: `1px solid ${theme.colors.neutral200}`,
          }),
    },
    arrowIcon: {
      transition: 'all .2s ease',
    },
    arrowPrev: {
      left: 0,
      [theme.fn.largerThan('sm')]: {
        left: showFullSlide ? rem(-60) : rem(-15),
      },
    },
    arrowNext: {
      right: 0,
      [theme.fn.largerThan('sm')]: {
        right: showFullSlide ? rem(-60) : rem(-15),
      },
    },
  }
})
